/**
 * Utility function to download a blob as a file
 * @param blob blob to download
 * @param filename filename to save as
 */
export const downloadBlobAsFile = (blob: Blob, filename?: string) => {
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = blobUrl;

  if (filename) link.download = filename;

  link.dispatchEvent(
    new MouseEvent("click", { bubbles: true, cancelable: true, view: window }),
  );

  setTimeout(() => URL.revokeObjectURL(blobUrl), 0);
};
/**
 * Utility function to download a URL as a file
 * @param url URL to download
 * @param filename Filename to save as (required)
 */
export const downloadUrlAsFile = async (url: string, filename: string) => {
  const response = await fetch(url);
  const blob = await response.blob();
  downloadBlobAsFile(blob, filename);
};

export const getExtensionFromDocumentType = (documentType?: string): string => {
  if (!documentType) return "";

  const extensionMap: Record<string, string> = {
    PDF: ".pdf",
    EXCEL_XLSX: ".xlsx",
    EXCEL_XLS: ".xls",
    WORD_DOCX: ".docx",
    WORD_DOC: ".doc",
    CSV: ".csv",
    ZIP: ".zip",
    PPTX: ".pptx",
    MP3: ".mp3",
    MP4: ".mp4",
    TEXT: ".txt",
    JSON: ".json",
    GZIP: ".gz",
    MPEG: ".mpeg",
    IMAGE: ".jpg",
    XXXX: "",
  };

  return extensionMap[documentType] || "";
};

export const getFilenameWithExtension = (
  filename: string,
  documentType?: string,
): string => {
  const extension = getExtensionFromDocumentType(documentType);

  return extension && !filename.endsWith(extension)
    ? `${filename}${extension}`
    : filename;
};

export const downloadUrlAsFileWithType = async (
  url: string,
  filename: string,
  documentType?: string,
) => {
  const response = await fetch(url);
  const contentType = response.headers.get("Content-Type");
  const arrayBuffer = await response.arrayBuffer();
  const blob = contentType
    ? new Blob([arrayBuffer], { type: contentType })
    : new Blob([arrayBuffer]);

  downloadBlobAsFile(blob, getFilenameWithExtension(filename, documentType));
};
